import theme from "./theme";
var button = function button(props) {
  return theme(props).button;
};
export var buttonPrimaryStyles = function buttonPrimaryStyles(props) {
  return button(props).primary;
};
export var buttonSecondaryStyles = function buttonSecondaryStyles(props) {
  return button(props).secondary;
};
export var buttonTertiaryStyles = function buttonTertiaryStyles(props) {
  return button(props).tertiary;
};
export var buttonSmallStyles = function buttonSmallStyles(props) {
  return button(props).small;
};
export var buttonMediumStyles = function buttonMediumStyles(props) {
  return button(props).medium;
};
export var buttonLargeStyles = function buttonLargeStyles(props) {
  return button(props).large;
};